export { default } from "/Users/kjensen/Sync/Learning/JavaScript/react-group-learn/etcpasswd/src/routes/index.tsx";